import { en } from './en';
import { sv } from './sv';

export const languages = {
    '1': en,
    '2': sv,
} as const;

export type LanguageData = typeof en;
